// extracted by mini-css-extract-plugin
export default {"card":"Card_card__fACaO","compntimg":"Card_compntimg__I3yyN","btnn":"Card_btnn__Xc2L5","cardbox":"Card_cardbox__F-dJ-"};